import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../hooks/useLogout";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import LabStepHeader from "./LabStepHeader";
import { Form } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyButton from "../../../MyComp/UI/form/MyButton";
import { createLabBankAPI, getLabDetailsFour, getLabDetailsTwo } from "../../../api/lab";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../../assets/constants";

const LabBank = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      qualificationDD: [],
      specializationDD: [],

      objectionKeys: [],
      approvedKeys: [],

      passbook: null,
      passbook_image: null,

      lab: [
        {
          image: null,
          image_url: null,
        },
      ],

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  // const { fields, append, remove } = useFieldArray({
  //   control,
  //   name: "lab",
  // });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "lab",
  });

  // Create a wrapped remove function
  const wrappedRemove = (index) => {
    const imageField = fields[index];

    // If this image has an ID (exists in database), track it for removal
    if (imageField?.id) {
      setRemovedImageIds((prev) => [...prev, imageField.id]);
    }

    // Call the original remove
    remove(index);
  };
  const [removedImageIds, setRemovedImageIds] = useState([]);
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const doctorId = location?.state?.doctorId || "";
  const queryParams = new URLSearchParams(location.search);
  const labId = queryParams.get("labId");
  const isLoading = watch("isLoading");
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    formData.append("labId", labId);
    formData.append("bankName", watch("bankName"));
    formData.append("accountNumber", watch("accountNumber"));
    formData.append("ifscCode", watch("ifscCode"));
    formData.append("upiId", watch("upiId"));

    const passbook = watch("passbook");
    if (passbook instanceof File) {
      formData.append("passbook", passbook);
    } else if (typeof passbook === "string") {
      formData.append("passbook", passbook);
    }

    // Append removed image IDs
    if (removedImageIds.length > 0) {
      removedImageIds.forEach((id, index) => {
        formData.append(`removesId[${index}]`, id);
      });
    }

    // Append lab images
    data?.lab?.forEach((item, index) => {
      if (item.image instanceof File) {
        // New file upload
        formData.append(`lab[${index}].image`, item.image);
      } else if (typeof item.image === "string" && item.image.startsWith("http")) {
        // Existing image URL - you might need to send this differently
        // or your backend might handle it automatically
        formData.append(`lab[${index}].image_url`, item.image);
      }
    });

    if (mode == "Add" || mode == "Edit") {
      createLabBankAPI(formData).then((res) => {
        if (res.data.status === true) {
          navigate(`/lab`);
          toast.success(res.data.message);
          toast.clearWaitingQueue();

          // Clear removed image IDs after successful submission
          setRemovedImageIds([]);
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }

    console.log("data", data);
    console.log("removed image IDs", removedImageIds);
  };
  // const onFormSubmit = (data) => {
  //   const formData = new FormData();
  //   formData.append("labId", labId);
  //   formData.append("bankName", watch("bankName"));
  //   formData.append("accountNumber", watch("accountNumber"));
  //   formData.append("ifscCode", watch("ifscCode"));
  //   formData.append("upiId", watch("upiId"));
  //   const passbook = watch("passbook");
  //   if (passbook instanceof File) {
  //     formData.append("passbook", passbook);
  //   } else if (typeof passbook === "string") {
  //     formData.append("passbook", passbook);
  //   }

  //   data?.lab?.forEach((item, index) => {
  //     formData.append(`lab[${index}].image`, item.image || "");
  //   });

  //   if (mode == "Add"|| mode=="Edit") {
  //         createLabBankAPI(formData).then((res) => {
  //           if (res.data.status === true) {
  //             navigate(`/lab`);
  //             toast.success(res.data.message);
  //             toast.clearWaitingQueue();
  //           } else if (res.data.status === false) {
  //             toast.error(res.data.message);
  //             toast.clearWaitingQueue();
  //           } else if (res.data.status === "expired") {
  //             toast.error(res.data.message);
  //             toast.clearWaitingQueue();
  //             logout();
  //           }
  //         });
  //       }

  //   console.log("data", data);
  // };
  useEffect(() => {
    if (mode === "Edit") {
      setBankAndLabFields();
    }
  }, [mode]);

  const handleRemoveImage = (index) => {
    const imageField = fields[index];
console.log(imageField,"imagefiled")
    // Check if this image has an ID (exists in database)
    if (imageField?.id) {
      // Add the ID to removedImageIds state
      setRemovedImageIds((prev) => [...prev, imageField.id]);
    }

    // Remove the field from field array
    remove(index);
  };

  const setBankAndLabFields = () => {
    getLabDetailsFour({ labId: location.state.labId })
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.data;

          setValue("bankName", data.bankName || "");
          setValue("accountNumber", data.accountNumber || "");
          setValue("ifscCode", data.ifscCode || "");
          setValue("upiId", data.upiId || "");

          if (data?.passbook) {
            const passbookUrl = `${BASE_URL_IMG}${data.passbook}`;

            setValue("passbook", passbookUrl);
            setValue("passbook_image", passbookUrl);
          } else {
            setValue("passbook", null);
            setValue("passbook_image", null);
          }

          if (data.lab_images && Array.isArray(data.lab_images)) {
            remove();

            data.lab_images.forEach((img) => {
              const imageUrl = `${BASE_URL_IMG}${img.url}`;

              append({
                image: imageUrl,
                image_url: imageUrl,
              });
            });
          } else {
            remove();
            append({ image: null, image_url: null });
          }

          trigger();
        } else if (res.data.status === "expired") {
          logout();
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <Head title={"Laboratory Registration | Bank & Documents"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Laboratory Registration"}
              </BlockTitle>
            </BlockHeadContent>
              <BlockHeadContent>
                          <div className="">
                            <Button
                              color="primary"
                              outline
                              className={`  me-n1`}
                              onClick={() => {
                                navigate(-1);
                              }}
                            >
                              <Icon name={"arrow-left"} />
                            </Button>
                          </div>
                        </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <LabStepHeader current={4} />
          <PreviewAltCard>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <Col xs="12" sm="6" md="4" lg="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Bank Account Holder Name"
                    name="bankName"
                    placeholder="Enter bank account holder name"
                    required
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Account Number"
                    name="accountNumber"
                    placeholder="Enter account number"
                    required
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="2">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="IFSC Code"
                    name="ifscCode"
                    placeholder="Enter ifsc code"
                    required
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="UPI ID"
                    name="upiId"
                    placeholder="Enter UPI id"
                    // required
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="passbook_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Bank Passbook /Cancelled Cheque"}
                    errors={errors}
                    register={register}
                    image={"passbook"}
                    image_url={"passbook_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    // required
                    validateDoc
                    disabled={mode == "Approval"}
                  />
                </Col>
                {fields.map((field, index) => (
                  <>
                    <Col md="2" key={field.id}>
                      <ImageUpload
                        getValues={getValues}
                        id={`image_${index}`}
                        watch={watch}
                        trigger={trigger}
                        setError={setError}
                        clearErrors={clearErrors}
                        errors={errors}
                        register={register}
                        label={`Lab Image ${index + 1}`}
                        image={`lab.${index}.image`}
                        image_url={`lab.${index}.image_url`}
                        setValue={setValue}
                        handleImageOpenPreview={handleImageOpenPreview}
                        rm
                        index={index}
                        remove={() => handleRemoveImage(index)} // Use custom remove handler
                        approve={mode === "Approval" ? true : false}
                        size={2048}
                      />
                    </Col>
                  </>
                ))}
                {/* {fields.map((field, index) => (
                  <>
                    <Col md="2" key={field.id}>
                      {" "}
                      <ImageUpload
                        getValues={getValues}
                        id={`image_${index}`}
                        watch={watch}
                        trigger={trigger}
                        setError={setError}
                        clearErrors={clearErrors}
                        errors={errors}
                        register={register}
                        label={`Lab Image ${index + 1}`}
                        image={`lab.${index}.image`}
                        image_url={`lab.${index}.image_url`}
                        setValue={setValue}
                        handleImageOpenPreview={handleImageOpenPreview}
                        // required
                        rm
                        index={index}
                        remove={remove}
                        approve={mode === "Approval" ? true : false}
                        size={2048}
                      />
                    </Col>
                  </>
                ))} */}
                {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                  <Col md="2">
                    <Button
                      style={{ marginTop: "30px" }}
                      type="button"
                      color="primary"
                      className=" "
                      id="addDegree"
                      onClick={() => {
                        append({ image: null, image_url: null });
                      }}
                    >
                      {"Add Image"}
                    </Button>{" "}
                  </Col>
                )}
              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default LabBank;
